<span #hintBubbleContent [ngClass]="state" class="hint-bubble-content">
  @if (position === 'above') {
    <div class="hint-bubble-arrow-above" [style.left.px]="arrowX"></div>
  }
  <ng-content></ng-content>
  @if (acceptLabel) {
    <a class="dismiss-link" (click)="onClickAccept($event)">{{ acceptLabel }}</a>
  }
  @if (position === 'below') {
    <div class="hint-bubble-arrow-below" [style.left.px]="arrowX"></div>
  }
</span>
